enum ApprovalStatus {
	Undefined = 0,
	Submitted = 1,
	Approved = 2,
	Rejected = 3,
	Removed = 4
}

export default ApprovalStatus;
